import React, { useContext, createContext, useReducer } from 'react';
import { ACTIONS_FAVORITES } from '../utils/_constants';

import { useUser } from './user-context';
import { isUser } from '../utils/user-services';
import { updateUserFavorites } from "../utils/user-services";

export const ACTIONS = ACTIONS_FAVORITES;

export const FAVORITES_TARGET = {
	LAUNCHES: 'launches',
	PADS: 'pads',
	
};

const FAVORITES_STORAGE_NAME = 'favorites';

const FavoritesContext = createContext();
const FavoritesUpdateContext = createContext();

export const useFavorites = () => useContext(FavoritesContext);
export const useFavoritesUpdate = () => useContext(FavoritesUpdateContext);


export const saveFavoritesOnLocalStorage = (favorites) => 
	localStorage.setItem(FAVORITES_STORAGE_NAME, JSON.stringify(favorites));

// weird mongoose bug where we cannot initialize correct empty object
// wasn't able to fix it via the documentation so we need to clean newly registered users favorites data this way
export const cleanInitialFavorites = (favorites) => { 
	if(!favorites.launches) return {launches:{}, pads: {}}
	else return favorites;
}

const getFavorites = () => {    
	const localStorageData = localStorage.getItem(FAVORITES_STORAGE_NAME);
	const initializeFavorites = () => {
		saveFavoritesOnLocalStorage({ launches: {}, pads: {} });
		return { launches: {}, pads: {} };
	}
	const favorites = localStorageData ? JSON.parse(localStorageData) : initializeFavorites();
	return favorites;
}

const initialFavorites = getFavorites();

export function FavoritesProvider({children}){

	const user = useUser();
	function favoritesReducer(favorites, action) {
		
		const newKey = action.payload.id;
		const target = action.payload.target;
		const data = action.payload.data;

		switch (action.type) {
			case ACTIONS.ADD: {    
				favorites[target][newKey] = data;
				saveFavoritesOnLocalStorage(favorites);
				if(isUser(user.username)) {
					updateUserFavorites(user.username, favorites)
				}
				return JSON.parse(JSON.stringify(favorites));// avoid shallow object comparison by creating a new one
			} 
			case ACTIONS.DELETE: {
				delete favorites[target][newKey]
				saveFavoritesOnLocalStorage(favorites);
				if(isUser(user.username)) {
					updateUserFavorites(user.username, favorites)
				}
				return JSON.parse(JSON.stringify(favorites));
			}
			case ACTIONS.CLEAR:
				favorites[target] = {};
				saveFavoritesOnLocalStorage(favorites);
				if(isUser(user.username)) {
					updateUserFavorites(user.username, favorites)
				}
				return JSON.parse(JSON.stringify(favorites));					
			case ACTIONS.SET: {
				favorites = data;
				saveFavoritesOnLocalStorage(favorites);
				return JSON.parse(JSON.stringify(favorites));
			}
			default:
				throw Error ('Unsupported Favorites Action');
		}
	}

	const [favorites, dispatch] = useReducer(favoritesReducer, initialFavorites);

	return (
		<FavoritesContext.Provider value={favorites}>
			<FavoritesUpdateContext.Provider value={dispatch}>
				{ children }
			</FavoritesUpdateContext.Provider>
		</FavoritesContext.Provider>
	)
}